module.exports = __webpack_public_path__ + "img/id-banner.62f80c8.jpeg";